
import { defineComponent } from "vue";

export default defineComponent({
  name: "WorkEnvironment",

  setup() {
    return {};
  },
});
